export default __webpack_public_path__ + "assets/4ce5a0e50d986e2158f9b9e378ce8cf6.jpg";